/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Datumfeedbackgespraech1Inputs */

const de__field_datumfeedbackgespraech1 = /** @type {(inputs: _Field_Datumfeedbackgespraech1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum Feedbackgesprách`)
};

/**

* @param {_Field_Datumfeedbackgespraech1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_datumfeedbackgespraech1 = /** @type {((inputs?: _Field_Datumfeedbackgespraech1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Datumfeedbackgespraech1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_datumfeedbackgespraech1(inputs)
});
export { _field_datumfeedbackgespraech1 as "_field_datumFeedbackgespraech" }